module.exports = __webpack_public_path__ + "static/media/ol-windbag.45d70778.png";